
<template>
<div class="partnerSwiper">
      <div class="btn button-prev" @click="prevBtn">
        <i class="el-icon-arrow-left"></i>
    </div>
    <div class="swiper-container" v-if="goodVisibility">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in partnerListN" :key="item.ID" >
                <!-- <img :src="item.image" :alt="item.partnerName" class="swiper-img" /> -->
              <div class="CNewItem"  @click="goProductItem(item)">
                <p class="CNewItemImg">
                    <el-image :src='item.TitlePic' class="fiveBoxBottomLImg">
                         <div slot="error" class="image-slot">
                           <img src="../../index/CpIcon.png" alt="">
                         </div>
                     </el-image>
                    <!-- <img src="../../index/ccjc.png" alt=""> -->
                </p>
                <p class="CNewItemTitle">{{item.Title}}</p>
                <p class="CNewItemText">{{item.Info}}</p>
                <p class="CNewItemBtn">了解详情</p>
              </div>
            </div>
        </div>
    </div>

    <div class="btn button-next" @click="nextBtn">
        <i class="el-icon-arrow-right"></i>
    </div>
</div>
</template>

<script>
// swiper使用版本@2.7.6
import Swiper from 'swiper/dist/idangerous.swiper.min.js' // npm引入方式
import 'swiper/dist/idangerous.swiper.css' // npm引入方式
// import Swiper from "@/style/idangerous.swiper.min.js";
// import "@/style/idangerous.swiper.css";
// import { partnerList } from "@/api/home/home.js";
export default {
  name: 'partner',
  props: ['productsList'],
  data () {
    return {
      partnerListN: [],
      partnerSwiper: null,
      partnerSwiperOption: {
        mode: 'horizontal', // Slides的滑动方向(水平)
        initialSlide: 0, // 设定初始化时slide的索引
        slidesPerView: 3, // 同时显示的幻灯片数量
        // updateOnImagesReady: true, // 所有内部图像（<img>标签）装入后重新初始化Swiper
        // resizeReInit: true, // windows改变尺寸时swiper会重新初始化
        loop: false // 循环模式

      },
      newsSwiper: this.productsList,
      goodVisibility: true
    }
  },
  created () {
    this.getPartnerList()
  },
  watch: {
    productsList: {
      handler (newVal) {
        // console.log(newVal, '12')
        this.partnerListN = newVal
        // console.log(this.partnerListN, 'sssss')
        this.getPartnerList()
        this.initSwiper()
        this.changeItem()
        // this.goodVisibility = false // 在html里通过v-if='goodVisibility '来控制
        // this.$nextTick(() => {
        //   this.goodVisibility = true
        // })
      },
      deep: true
    }
  },
  methods: {
    // 获取合作伙伴列表
    getPartnerList () {
      this.$nextTick(() => {
        this.initSwiper()
      })
    },
    // 初始化swiper
    initSwiper () {
      this.partnerSwiper = new Swiper('.swiper-container', this.partnerSwiperOption)
    },
    // 上一张
    prevBtn () {
      this.partnerSwiper.swipePrev()
    },
    // 下一张
    nextBtn () {
      this.partnerSwiper.swipeNext()
    },
    // 跳转
    goProductItem (item) {
      // console.log('lll')
      // this.$router.push(newsItem)
      this.$router.push({ path: `/productItemShow/${item.ID}` })
      this.$store.commit('getActiveIndex', '/productMain')
    },
    changeItem () {
      this.partnerSwiper.mySwiper.swipeTo(0)
    }
  }
}
</script>
<style lang="scss">
$sun:100/192;
.partnerSwiper{
  width: 100%;
  height: 100%;
  position: relative;
}
.button-prev{
  position: absolute;
  left: 0;
  top: 50%;
  cursor: pointer;
}
.button-next{
  position: absolute;
  top: 50%;
  right: 0;
  cursor: pointer;
}
.swiper-container{
  margin: auto;
  width: 1020px*$sun;
  height: 100%;
}
// item项
.CNewItem{
    width: 320px*$sun;
    height: 460px*$sun;
    background: #FFFFFF;
    // display: flex;
    // flex-direction: column;
    // justify-content: space-between;
    // align-items: center;
    overflow: hidden;
    padding-top: 26px*$sun;
    padding-bottom: 36px*$sun;
    box-sizing: border-box;
    // transition: ease 1s;
    // transition:all 1s;
    margin: 0 10px*$sun;
    .CNewItemImg{
        width: 46px*$sun;
        height: 46px*$sun;
        margin: 0 auto;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .CNewItemTitle{
        width: 100%;
        height: 30px*$sun;
        font-size: 22px*$sun;
        text-align: center;
        font-weight: 500;
        // margin: 0 auto;
    }
    .CNewItemText{
        width: 244px*$sun;
        height: 220px*$sun;
        font-size: 14px*$sun;
        color: #666666;
        line-height: 28px*$sun;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 8; /* 显示三行，后面省略 */
        overflow: hidden;
        margin: 0 auto;
        font-weight: 500;
    }
    .CNewItemBtn{
        min-width: 106px*$sun;
        width: 106px*$sun;
        height: 31px*$sun;
        font-size: 14px*$sun;
        text-align: center;
        background: #2380E1;
        color: #FFFFFF;
        border-radius: 6px*$sun;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        font-weight: 500;
        cursor: pointer;
    }

  }
  .CNewItem:hover{
    background: #2380E1;
    color: #fff;
    .CNewItemText{
    color: #fff;
  }
   .CNewItemImg{
    display: none;
  }
  .CNewItemBtn{
    display: none;
  }
  }
  // .CNewItem:hover .CNewItemText{
  //   color: #fff;
  // }
  // .CNewItem:hover .CNewItemImg{
  //   display: none;
  // }
  // .CNewItem:hover .CNewItemBtn{
  //   display: none;
  // }
</style>
